import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { DialogModule } from '@angular/cdk/dialog';

import { SgCoreModule } from '@sg/ui-kit/core/src';
import { SgEntityBasedSession } from '@sg/common/src';
import { CookiesConsentDialogComponent } from './cookies-consent-dialog/cookies-consent-dialog.component';
import { CookiesSettingsComponent } from './cookies-settings/cookies-settings.component';
import { CookiesSettingsDialogComponent } from './cookies-settings-dialog-wrapper/cookies-settings-dialog-wrapper.component';

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    SgCoreModule,
    MatButtonModule,
    MatExpansionModule,
    MatSlideToggleModule,
    ReactiveFormsModule,
    MatDialogModule,
    DialogModule,
    MatIconModule,
  ],
  declarations: [CookiesConsentDialogComponent, CookiesSettingsComponent, CookiesSettingsDialogComponent],
  exports: [CookiesConsentDialogComponent, CookiesSettingsComponent, CookiesSettingsDialogComponent],
  providers: [
    {
      provide: SgEntityBasedSession,
      useExisting: SgEntityBasedSession,
    },
  ],
})
export class SgCookiesConsentModule {
  constructor() {}
}
